"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var popup = __importStar(require("./src/features/popup"));
var attachment_buttons = __importStar(require("./src/features/attachment-buttons"));
var notifications = __importStar(require("./src/features/notifications"));
var multi_select_features = __importStar(require("./src/features/multi-select-actions"));
var resources = __importStar(require("./src/resources/index"));
var events = __importStar(require("./src/events"));
var widgets = __importStar(require("./src/widgets/index"));
var examples = __importStar(require("./src/examples"));
var html_components = __importStar(require("./src/html-components"));
var alpinejs_1 = __importDefault(require("alpinejs"));
require('./bootstrap');
window.Alpine = alpinejs_1.default;
alpinejs_1.default.start();
attachment_buttons.init();
popup.init();
notifications.init();
multi_select_features.init();
events.register_events();
widgets.init();
resources.init();
html_components.init();
// example
examples.init();
